const INITIAL_STATE = {listContagem: []}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'GRAFICO_CONTAGEM_FETCHED':
            return { ...state, listContagem: action.payload.data }
        default:
            return state
    }
}
